/**
 * Display / filter label for a material row.
 * - Project materials: API `projectName` from project master join (via projectId).
 * - Warehouse inventory: free-text `project_name` / `warehouseProjectLabel` saved on create.
 * - Some API payloads nest the join as `project.project_name` / `project.projectName`.
 */
export function getMaterialProjectName(
  row: Record<string, unknown> | null | undefined
): string {
  if (!row) return '';
  const details = row.details as Record<string, unknown> | undefined;
  const nestedProject =
    row.project && typeof row.project === 'object'
      ? (row.project as Record<string, unknown>)
      : undefined;
  const candidates = [
    row.projectName,
    row.warehouseProjectLabel,
    row.project_name,
    nestedProject?.projectName,
    nestedProject?.project_name,
    details?.projectName,
    details?.warehouseProjectLabel,
    details?.project_name,
  ];
  for (const value of candidates) {
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }
  return '';
}
